
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"red"}},[_c('path',{attrs:{"d":"M436 1c-10.4 1.9-20.7 6.6-28.7 12.9-6.9 5.4-236 256.3-238.8 261.5-1.3 2.2-8.3 22.1-15.6 44.1-13.2 39.5-13.4 40.1-13.4 49 0 7.4.4 9.7 2.3 13.3 6.4 11.9 19.6 18.6 32.2 16.2 5.6-1.1 83.8-34.8 88.6-38.3 5.1-3.6 232.5-253.2 237.6-260.8 6.8-10 10-20.7 10.2-33.4.1-12-1.3-18.3-6.6-29.5-7.2-15.2-23.1-28.5-39.8-33.4-6.5-2-21.7-2.8-28-1.6zm18.5 44.9c11.7 5.3 15.9 19.8 8.6 29.8-1.6 2.1-46.1 51.2-99 109.1l-96.3 105.3-9.6-8.9c-5.3-4.9-12.1-11.1-15-13.8l-5.2-4.9 98.1-107.3c77.6-84.9 99-107.8 102.3-109.3 5.2-2.4 11-2.4 16.1 0zM226.8 312c9 8.2 11 10.6 10 11.5-2 1.8-43.8 19.8-44.4 19.2-.6-.6 12.9-42.3 14.8-46.1.9-1.7 1.3-1.6 4.6 1.6 2.1 1.9 8.8 8.1 15 13.8z"}}),_c('path',{attrs:{"d":"M92.1 48.1C44.5 52.4 6.9 89.8 2 137.7c-.8 7.5-1 53.1-.8 149.3.4 127.3.5 139.1 2.1 145.7 9.2 38 35.9 65.7 73.3 76.1l9.9 2.7h296l9.9-2.7c41.1-11.4 69.5-44 74.6-85.8 1.5-12.5 1.4-197.6-.2-203.8-1.7-6.9-8.7-13.6-16-15.2-4.6-1.1-6.3-1-11 .4-6.6 1.9-13 8.2-14.7 14.2-.7 2.7-1.1 35.1-1.1 101 0 64.5-.4 99-1.1 103-2.9 16.3-15.1 32.1-30.2 39.3-4.5 2.2-10.6 4.4-13.5 5-7.4 1.5-282 1.5-289.4 0-8.3-1.7-20.6-8.1-26.6-13.8-6.4-6.2-12.3-15.1-15.4-23.4l-2.3-6.2-.3-141C45 144.6 45 141.4 47 133.7c4.7-18.7 17.5-32.3 38-40.1 5.4-2.1 6.7-2.1 111.1-2.6l105.5-.5 4.2-2.8c5.8-3.8 9.2-9.3 9.9-15.9 1-9.8-3.7-18.1-12.7-22.2-4.5-2.1-5.4-2.1-103-2.2-54.2-.1-102.7.2-107.9.7z"}})])])
          )
        }
      }
    